import { Component, Input } from 'angular-ts-decorators';

import { IGroupRetailer } from '@gn-audio/core/api/retailers/models';

import template from './buy-exclusively.component.html';

@Component({
  selector: 'buyExclusively',
  template,
})
export class BuyExclusivelyComponent {
  @Input() public readonly retailer: IGroupRetailer;
}
